// material-ui
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })<{ open: boolean }>(({ theme }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: theme.spacing(0),
  transition: theme.transitions.create(['padding', 'minHeight'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: { 
        justifyContent: 'flex-start', 
        paddingLeft: theme.spacing(3),
        minHeight: 'auto'
      }
    }
  ]
}));

export default DrawerHeaderStyled;
